import axios from 'axios';
import { getSsoToken } from './teams.js';

const API_URL = import.meta.env.VITE_API_URL;
const API_KEY = import.meta.env.VITE_API_KEY;

const client = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    ...(API_KEY ? { 'x-api-key': API_KEY } : {})
  }
});

client.interceptors.request.use(async (config) => {
  try {
    const token = await getSsoToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (_) {
    // En desarrollo local sin Teams, el SSO falla; seguimos solo con x-api-key.
  }
  return config;
});

export const markAttendance = async (payload) => {
  const { data } = await client.post('/attendance/mark', payload);
  return data?.data;
};

export const getMyDay = async () => {
  const { data } = await client.get('/attendance/my-day');
  return data?.data;
};

export const setCanonicalMark = async (mark_id) => {
  const { data } = await client.post('/attendance/canonical', { mark_id });
  return data?.data;
};
